import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import DispositionDetail from 'src/app/interfaces/disposition-detail';
import ProjectDetail from 'src/app/interfaces/project-detail';
import { DispositionsDetailsService } from './dispositions-details.service';
import { Subscription } from 'rxjs';
import { UpdateDispositionDetailInput } from './graphql/dispositions-details';
@Component({
    selector: 'dispositions-details',
    templateUrl: './dispositions-details.component.html',
    styleUrls: ['./dispositions-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DispositionsDetailsComponent {
  @Input() projectId: string | null;

  public dispositionDetailsSub: Subscription;
  public projectDetailsSub: Subscription;

  public dispositionDetail: DispositionDetail | null = null;
  public projectDetail: ProjectDetail | null = null;

  constructor(public dispositionDetailService: DispositionsDetailsService) {}

  ngOnInit() {
    if (this.projectId) {
      this.dispositionDetailService.getDispositionDetail(this.projectId);
    }

    this.dispositionDetailsSub =
      this.dispositionDetailService.dispositionDetail$.subscribe(
        (dispositionDetail) => {
          if (dispositionDetail) {
            this.dispositionDetail = structuredClone(dispositionDetail);
          }
        }
      );
    this.projectDetailsSub =
      this.dispositionDetailService.projectDetail$.subscribe(
        (projectDetail) => {
          if (projectDetail) {
            this.projectDetail = structuredClone(projectDetail);
          }
        }
      );
  }
  ngOnDestroy() {
    this.dispositionDetailsSub?.unsubscribe();
    this.projectDetailsSub?.unsubscribe();
  }
  filterFields(): UpdateDispositionDetailInput | null {
    if (this.dispositionDetail) {
      let {
        disposition_gp_transfer_status_id,
        disposition_refinancing_status_id,
        forced_sale_right,
        disposition_notes,
      } = this.dispositionDetail;
      return {
        disposition_gp_transfer_status_id,
        disposition_refinancing_status_id,
        forced_sale_right,
        disposition_notes,
      };
    }
    return null;
  }
  saveDetails() {
    if (this.dispositionDetail && this.projectDetail && this.projectDetail.id) {
      let disposition_detail_input = this.filterFields();
      let project_details_input = {
        fully_disposed: this.projectDetail.fully_disposed ?? null,
      };
      if (disposition_detail_input)
        this.dispositionDetailService.updateDispositionDetail(
          this.dispositionDetail.id,
          disposition_detail_input,
          this.projectDetail.id,
          project_details_input
        );
    }
  }
}
